import React, { Component } from 'react';
import { Table, Segment } from 'semantic-ui-react'

import find from 'lodash/find'
import constants from '../../constants';

const _ = { find }
const breakdownOfFees = constants.breakdownOfFees;
const tuitionFeeSched = constants.tuitionFeeSched;

export class ApplicationDetails extends Component {

  getStatus = () => {
    // Assessing Academic Requirements
    // Previous School Grades Needed

    // Assesing Previous School Years Balance
    // Email Sent
    // Awaiting for Payment
    // Paid and Enrolled

    let status = '', description = '';
    const { applicant } = this.props;
    if (applicant.applicationType === 'old') {
      if (applicant.sentEmail) {
        if (applicant.clearToEnroll === 'Ok' || applicant.clearToEnroll === 'Temp') {
          if (applicant.hasPromisoryNote) {
            if (applicant.isPartiallyPaid) {
              if (applicant.isPaid && applicant.isPartiallyPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Partially Enrolled'
                description = `We received your reservation payment. Please settle the balance: ${applicant.ueBalance} before the start of classes.`
              }
            } else {
              if (applicant.isPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Payment Details sent via Email - Waiting for Payment'
                description = `
                  Please check your email for details. If you have questions don't hesitate to contact us via enrollment@salisonline.com.
                `
              }
            }
            status = 'Promisory Note Submitted'
            description = 'You already submitted your promisory note. You can attend classes but you will not be included as officially enrolled student.'
          } else {
            if (applicant.isPartiallyPaid) {
              if (applicant.isPaid && applicant.isPartiallyPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Partially Enrolled'
                description = `We received your reservation payment. Please settle the balance: ${applicant.ueBalance} before the start of classes.`
              }
            } else {
              if (applicant.isPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Payment Details sent via Email - Waiting for Payment'
                description = `
                  Please check your email for details. If you have questions don't hesitate to contact us via enrollment@salisonline.com.
                `
              }
            }
          }
        } else {
          status = 'Pending Balance'
          description = `
            You have pending balance from the previous year. Please check your email for details.
          `
        }
      } else {
        status = 'Checking Previous Year Balance';
        description = 'We are currently checking your previous school year balance.'
      }

    } else {
      if (applicant.isPassed && applicant.sentAAEmail) {
        if (applicant.sentEmail) {
          if (applicant.hasPromisoryNote) {
            if (applicant.isPartiallyPaid) {
              if (applicant.isPaid && applicant.isPartiallyPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Partially Enrolled'
                description = `We received your reservation payment. Please settle the balance: ${applicant.ueBalance} before the start of classes.`
              }
            } else {
              if (applicant.isPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Payment Details sent via Email - Waiting for Payment'
                description = `
                  Please check your email for details. If you have questions don't hesitate to contact us via enrollment@salisonline.com.
                `
              }
            }
            status = 'Promisory Note Submitted'
            description = 'You already submitted your promisory note. You can attend classes but you will not be included as officially enrolled student.'
          } else {
            if (applicant.isPartiallyPaid) {
              if (applicant.isPaid && applicant.isPartiallyPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Partially Enrolled'
                description = `We received your reservation payment. Please settle the balance: ${applicant.ueBalance} before the start of classes.`
              }
            } else {
              if (applicant.isPaid) {
                if (applicant.isCurrentStudent) {
                  status = 'Enrolled!!!'
                  description = 'You are now officially enrolled. Official receipts are available upon request.'
                } else {
                  status = 'Payment Done'
                  description = 'Thank you for your payment. You can get back to this page for your class and section.'
                }
              } else {
                status = 'Payment Details sent via Email - Waiting for Payment'
                description = `
                  Please check your email for details. If you have questions don't hesitate to contact us via enrollment@salisonline.com.
                `
              }
            }
          }
        } else {
          status = 'Passed Academic Assessment'
          description = 'Congratulations! You passed the academic assessment. You will receive another email regarding the payment details.'
        }
      } else {
        status = 'Checking Academic Requirements';
        description = 'We are currently checking your academic requirements. If you did not attach a past grade you can contact us at enrollment@salisonline.com for faster transaction.'
      }

    }

    return { status, description };
  }

  render() {
    const { applicant } = this.props;
    const status = this.getStatus();
    let breakdownLevel, scheduleOfPayment, ue, amt;
    if (applicant.gradeLevel) {
      breakdownLevel = _.find(breakdownOfFees, {
        gradeLevel: applicant.gradeLevel
      });
    }

    if (applicant.paymentSchedule) {
      scheduleOfPayment = _.find(tuitionFeeSched, {
        gradeLevel: applicant.gradeLevel
      });

      if (applicant.paymentSchedule === 'Full Cash Basis') {
        ue = scheduleOfPayment.cash;
        amt = '';
      } else if (applicant.paymentSchedule === 'Semi-Annual'){
        ue = scheduleOfPayment.uponEnrollmentSemi;
        amt = scheduleOfPayment.semi;
      } else if (applicant.paymentSchedule === 'Quarterly'){
        ue = scheduleOfPayment.uponEnrollmentQuarterly;
        amt = scheduleOfPayment.quarterly;
      } else if (applicant.paymentSchedule === 'Monthly Basis'){
        ue = scheduleOfPayment.uponEnrollmentMonthly;
        amt = scheduleOfPayment.monthly;
      } else {
        ue = '';
        amt = '';
      }
    }
    return (
      <Segment>
        <h2> {applicant.lastName}, {applicant.firstName}</h2>
        <h3>STATUS: {status.status}</h3>
        <span>{status.description}</span>
          <div style={{marginTop: '14px', marginBottom: '14px'}}>
            <span>Breakdown of Fees</span>
            <Table unstackable celled size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>LEVEL</Table.HeaderCell>
                  <Table.HeaderCell>TUITION FEES</Table.HeaderCell>
                  <Table.HeaderCell>MISC FEES</Table.HeaderCell>
                  <Table.HeaderCell>BOOKS & MAGAZINES</Table.HeaderCell>
                  <Table.HeaderCell>TOTAL</Table.HeaderCell>
                  <Table.HeaderCell>SUBSIDY</Table.HeaderCell>
                  <Table.HeaderCell>TOTAL (TF, MISC, BOOKS)</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>{breakdownLevel.gradeLevel}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.tuition}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.misc}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.books}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.total}</Table.Cell>
                  <Table.Cell textAlign='right' color='green'>{breakdownLevel.subsidy}</Table.Cell>
                  <Table.Cell textAlign='right'><strong>{breakdownLevel.grandTotal}</strong></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
          <div style={{marginBottom: '14px'}}>
            <span>Payment Schedule</span>
            <Table unstackable celled size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>LEVEL</Table.HeaderCell>
                  <Table.HeaderCell>PAYMENT SCHEDULE</Table.HeaderCell>
                  <Table.HeaderCell>UPON ENROLLMENT</Table.HeaderCell>
                  <Table.HeaderCell>NEXT PAYMENT</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>{scheduleOfPayment.gradeLevel}</Table.Cell>
                  <Table.Cell textAlign='right'>{applicant.paymentSchedule}</Table.Cell>
                  <Table.Cell textAlign='right'>{ue}</Table.Cell>
                  <Table.Cell textAlign='right'>{amt}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
          <span> NOTE: Subsidies, vouchers, and other grants are not yet included in this computation. Your actual computation will be sent to you after the assessment.</span>
      </Segment>
    );
  }
}

export default ApplicationDetails;
